import { EditOutlined, MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Card, Drawer, Form, Input, InputNumber, Select, Spin, Typography } from "antd";
import { useState } from "react";
import { commaSeparateNumber } from "utils/functions";
import "./index.css";
import SizeTracking from "./SizeTracking";

const PackingDetails = (props) => {
  // Props
  const {
    isView,
    view,
    styleList,
    styleListLoading,
    poDetailsData,
    copyRow,
    removeRow,
    onChangePoDetailsValue,
    calculateQty,
    calculateCBM,
    calculateTotalGrossWeight,
    calculateTotalNetWeight,
    selectedPoColorList,
    fetchStyleColors,
    poList,
    PackReqForm,
    selectedPOUniqueID,
    setSelectedPOUniqueID,
    insertSizeTableData,
    isEdit,
    setPoDetailsData,
    useSubStyleFromDetails,
    packingTypes,
  } = props;

  // States
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [hoverData, setHoverData] = useState(null);

  // Antd
  const [packingDetailsForm] = Form.useForm();
  const { Option } = Select;
  const { Title } = Typography;

  const RowInfoUI = ({ rowData }) => {
    return (
      <div style={{ padding: "10px", display: rowData ? "unset" : "none" }} className="row-ui-bottom">
        <div>
          <strong>Carton Qty:</strong> {rowData?.carton_qty ? commaSeparateNumber(rowData?.carton_qty) : "N/A"},
          <strong>CBM:</strong> {rowData?.cbm || "N/A"},<strong>Item:</strong> {rowData?.item || "N/A"},
          <strong>Total Gross:</strong> {rowData?.total_gross ? commaSeparateNumber(rowData?.total_gross) : "N/A"},
          <strong>Total Net:</strong> {rowData?.total_net ? commaSeparateNumber(rowData?.total_net) : "N/A"}
          <strong>UPC: </strong> {rowData?.upc || "N/A"}
        </div>
      </div>
    );
  };

  const openDrawer = (uniqueId) => {
    setSelectedPOUniqueID(uniqueId);
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <>
      <Form form={packingDetailsForm}>
        <div className="">
          <Card className="mt-2" title={<span style={{ fontSize: "14px", fontWeight: 600 }}>Style PO Details</span>}>
            <Spin spinning={!!styleListLoading}>
              <div className="custome-table">
              <table>
                <thead>
                  <tr>
                    {/* Carton Details */}
                    <th colSpan={7} className="bc-orange text-center">
                      Carton Details
                    </th>
                    {/* Carton Size */}
                    <th colSpan={5} className="bc-orange text-center">
                      Carton Size
                    </th>
                    {/* Weight / Carton */}
                    <th colSpan={2} className="bc-orange text-center">
                      Weight (kg) / Carton
                    </th>
                    {/* Total Weight */}
                    <th colSpan={2} className="bc-orange text-center">
                      Total Weight (kg)
                    </th>
                    {/* Style & Packing Type */}
                    <th colSpan={2} className="bc-orange text-center">
                      Style & Packing Type
                    </th>
                    <th colSpan={3} className="bc-orange text-center">
                      Actions/Row
                    </th>
                  </tr>
                  <tr>
                    <th key="header_serial_number" className="bc-java text-center">
                      SL
                    </th>
                    <th key="header_packing_type" className="bc-java text-center">
                      Packing Type <span className="required">*</span>
                    </th>
                    <th key="header_from" className="bc-java text-center">
                      From <span className="required">*</span>
                    </th>
                    <th key="header_to" className="bc-java text-center">
                      To <span className="required">*</span>
                    </th>
                    <th key="header_qty" className="bc-java text-center">
                      Qty <span className="required">*</span>
                    </th>
                    <th key="header_customer_po" className="bc-java text-center">
                      Customer PO
                    </th>
                    <th key="header_assortment" className="bc-java text-center">
                      Assortment
                    </th>
                    <th key="header_item" className="bc-java text-center">
                      Item
                    </th>
                    <th key="header_upc" className="bc-java text-center">
                      UPC
                    </th>
                    <th key="header_length" className="bc-java text-center">
                      L (cm) <span className="required">*</span>
                    </th>
                    <th key="header_width" className="bc-java text-center">
                      W (cm) <span className="required">*</span>
                    </th>
                    <th key="header_height" className="bc-java text-center">
                      H (cm) <span className="required">*</span>
                    </th>
                    <th key="header_cbm" className="bc-java text-center">
                      CBM <span className="required">*</span>
                    </th>
                    <th key="header_cbm" className="bc-java text-center">
                      Total CBM
                    </th>
                    <th key="header_weight_gross" className="bc-java text-center">
                      Gross <span className="required">*</span>
                    </th>
                    <th key="header_weight_net" className="bc-java text-center">
                      Net <span className="required">*</span>
                    </th>
                    <th key="header_total_weight_gross" className="bc-java text-center">
                      Gross <span className="required">*</span>
                    </th>
                    <th key="header_total_weight_net" className="bc-java text-center">
                      Net <span className="required">*</span>
                    </th>
                    {/* Size Ratio action next */}
                    {!view && (
                      <th key="header_input_row" className="bc-java text-center">
                        Size Ratio
                      </th>
                    )}
                    {!view && (
                      <>
                        <th key="header_add_row" className="bc-java text-center">
                          Add
                        </th>
                        <th key="header_delete_row" className="bc-java text-center">
                          Delete
                        </th>
                      </>
                    )}
                  </tr>
                </thead>

                <tbody className="scrollable-table-container">
                  {poDetailsData && poDetailsData?.length > 0 ? (
                    <>
                      {poDetailsData.map((obj, index) => {
                        return (
                          <tr
                            key={`table_parent_key_${index}`}
                            onMouseEnter={() => setHoverData(obj)}
                            onMouseLeave={() => setHoverData(null)}
                          >
                            {/* SL */}
                            <td className="t-body sticky">{index + 1}</td>
                            <td className="t-body sticky">
                              <Select
                                onChange={(value) => {
                                  onChangePoDetailsValue(value, obj?.unique_id, "packing_type_id");
                                }}
                                showSearch
                                style={{ width: "100%" }}
                                placeholder="Select"
                                optionFilterProp="children"
                                defaultActiveFirstOption={false}
                                value={obj?.packing_type_id}
                                size="small"
                                disabled={isView}
                              >
                                {packingTypes &&
                                  packingTypes?.length > 0 &&
                                  packingTypes?.map((po, idx) => (
                                    <Option key={idx} value={po?.id}>
                                      {po?.name}
                                    </Option>
                                  ))}
                              </Select>
                            </td>
                            <td className="t-body sticky">
                              <InputNumber
                                style={{ width: "80px" }}
                                placeholder="From"
                                value={obj?.start_range}
                                formatter={(value) => commaSeparateNumber(value)}
                                precision={0}
                                size="small"
                                disabled
                              />
                            </td>
                            {/* To (end_range) - read only, managed via SizeTracking */}
                            <td className="t-body sticky">
                              <InputNumber
                                style={{ width: "80px" }}
                                placeholder="To"
                                value={obj?.end_range}
                                formatter={(value) => commaSeparateNumber(value)}
                                precision={0}
                                size="small"
                                disabled
                              />
                            </td>
                            {/* Qty (carton_qty) */}
                            <td className="t-body sticky">
                              <InputNumber
                                style={{ width: "80px" }}
                                placeholder="Qty"
                                value={obj?.carton_qty}
                                disabled
                                formatter={(value) => commaSeparateNumber(value)}
                                precision={2}
                                size="small"
                              />
                            </td>
                            {/* Customer PO */}
                            <td className="t-body sticky">
                              <Input
                                style={{ width: "120px" }}
                                placeholder="Customer PO"
                                value={obj?.customer_po}
                                onChange={(event) => {
                                  onChangePoDetailsValue(event.target.value, obj?.unique_id, "customer_po");
                                }}
                                size="small"
                                disabled={isView}
                              />
                            </td>
                            {/* Assortment */}
                            <td className="t-body sticky">
                              <Input
                                style={{ width: "80px" }}
                                placeholder="Assortment"
                                value={obj?.assortment}
                                onChange={(event) => {
                                  onChangePoDetailsValue(event.target.value, obj?.unique_id, "assortment");
                                }}
                                size="small"
                                disabled={isView}
                              />
                            </td>
                            {/* Item */}
                            <td className="t-body sticky">
                              <Input
                                style={{ width: "80px" }}
                                placeholder="Item"
                                value={obj?.item}
                                onChange={(event) => {
                                  onChangePoDetailsValue(event.target.value, obj?.unique_id, "item");
                                }}
                                size="small"
                                disabled={isView}
                              />
                            </td>
                            {/* UPC */}
                            <td className="t-body sticky">
                              <Input
                                style={{ width: "80px" }}
                                placeholder="UPC"
                                value={obj?.upc}
                                onChange={(event) => {
                                  onChangePoDetailsValue(event.target.value, obj?.unique_id, "upc");
                                }}
                                size="small"
                                disabled={isView}
                              />
                            </td>
                            {/* Length */}
                            <td className="t-body sticky">
                              <InputNumber
                                style={{ width: "80px" }}
                                placeholder="Length"
                                value={obj?.length}
                                onChange={(value) => {
                                  onChangePoDetailsValue(value, obj?.unique_id, "length");
                                  calculateCBM(obj?.unique_id);
                                }}
                                precision={2}
                                size="small"
                                disabled={isView}
                              />
                            </td>
                            {/* Width */}
                            <td className="t-body sticky">
                              <InputNumber
                                style={{ width: "80px" }}
                                placeholder="Width"
                                value={obj?.width}
                                onChange={(value) => {
                                  onChangePoDetailsValue(value, obj?.unique_id, "width");
                                  calculateCBM(obj?.unique_id);
                                }}
                                precision={2}
                                size="small"
                                disabled={isView}
                              />
                            </td>
                            {/* Height */}
                            <td className="t-body sticky">
                              <InputNumber
                                style={{ width: "80px" }}
                                placeholder="Height"
                                value={obj?.height}
                                onChange={(value) => {
                                  onChangePoDetailsValue(value, obj?.unique_id, "height");
                                  calculateCBM(obj?.unique_id);
                                }}
                                precision={2}
                                size="small"
                                disabled={isView}
                              />
                            </td>
                            {/* CBM */}
                            <td className="t-body sticky">
                              <InputNumber
                                style={{ width: "80px" }}
                                placeholder="CBM"
                                value={obj?.cbm}
                                disabled
                                size="small"
                              />
                            </td>
                            {/* Total CBM */}
                            <td className="t-body sticky">
                              <InputNumber
                                style={{ width: "80px" }}
                                placeholder="Total CBM"
                                value={obj?.total_cbm}
                                disabled
                                size="small"
                              />
                            </td>
                            {/* Carton Gross */}
                            <td className="t-body sticky">
                              <InputNumber
                                style={{ width: "80px" }}
                                placeholder="Gross"
                                value={obj?.gross}
                                onChange={(value) => {
                                  onChangePoDetailsValue(value, obj?.unique_id, "gross");
                                  calculateTotalGrossWeight(obj?.unique_id);
                                }}
                                formatter={(value) => commaSeparateNumber(value)}
                                precision={2}
                                size="small"
                                disabled={isView}
                              />
                            </td>
                            {/* Carton Net */}
                            <td className="t-body sticky">
                              <InputNumber
                                style={{ width: "80px" }}
                                placeholder="Net"
                                value={obj?.net}
                                onChange={(value) => {
                                  onChangePoDetailsValue(value, obj?.unique_id, "net");
                                  calculateTotalNetWeight(obj?.unique_id);
                                }}
                                formatter={(value) => commaSeparateNumber(value)}
                                precision={2}
                                size="small"
                                disabled={isView}
                              />
                            </td>
                            {/* Total Gross */}
                            <td className="t-body sticky">
                              <InputNumber
                                style={{ width: "80px" }}
                                placeholder="Gross"
                                value={obj?.total_gross}
                                disabled
                                formatter={(value) => commaSeparateNumber(value)}
                                precision={2}
                                size="small"
                              />
                            </td>
                            {/* Total Net */}
                            <td className="t-body sticky">
                              <InputNumber
                                style={{ width: "80px" }}
                                placeholder="Net"
                                value={obj?.total_net}
                                disabled
                                formatter={(value) => commaSeparateNumber(value)}
                                precision={2}
                                size="small"
                              />
                            </td>

                            {/* Size Ratio (drawer trigger) - directly after Style */}
                            {(!view || !isView) && (
                              <td
                                className="t-body"
                                onClick={() => {
                                  openDrawer(obj?.unique_id);
                                }}
                              >
                                <EditOutlined className="cursore-pointer" style={{ fontSize: "16px" }} />
                              </td>
                            )}
                            {/* From (start_range) - read only, managed via SizeTracking */}
                            {!isView && (
                              <td
                                className="t-body"
                                onClick={() => {
                                  copyRow(obj?.unique_id);
                                }}
                              >
                                <PlusCircleOutlined
                                  className="cursore-pointer"
                                  style={{ fontSize: "16px", color: "Green" }}
                                />
                              </td>
                            )}
                            {!isView && (
                              <td
                                className="t-body"
                                onClick={() => {
                                  removeRow(obj?.unique_id);
                                }}
                              >
                                <MinusCircleOutlined
                                  className="cursore-pointer"
                                  style={{ fontSize: "16px", color: "red" }}
                                />
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </>
                  ) : (
                    ""
                  )}
                </tbody>
              </table>
            </div>
            </Spin>
          </Card>
          <Drawer title="Item Input" placement="right" onClose={closeDrawer} open={isDrawerOpen} width="90%">
            <SizeTracking
              selectedPoColorList={selectedPoColorList}
              poDetailsData={poDetailsData}
              PackReqForm={PackReqForm}
              selectedPOUniqueID={selectedPOUniqueID}
              isDrawerOpen={isDrawerOpen}
              closeDrawer={closeDrawer}
              insertSizeTableData={insertSizeTableData}
              isEdit={isEdit}
              setPoDetailsData={setPoDetailsData}
              view={isView}
              useSubStyleFromDetails={useSubStyleFromDetails}
              styleList={styleList}
              fetchStyleColors={fetchStyleColors}
              poList={poList}
            />
          </Drawer>
        </div>
      </Form>
      <div>
        <RowInfoUI rowData={hoverData} className="row-ui-bottom" size="small" />
      </div>
    </>
  );
};
export default PackingDetails;
